import { render } from "./FormacaoPrecoIndex.vue?vue&type=template&id=268d1135&ts=true"
import script from "./FormacaoPrecoIndex.vue?vue&type=script&lang=ts"
export * from "./FormacaoPrecoIndex.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__